export default __webpack_public_path__ + "static/media/cot1.50c5ee52.jpg";